export default {
  autoHeight: {
    height: 'auto',
    paddingTop: 'env(safe-area-inset-top)'
  },

  iconColor: {
    error: {
      color: '#f49696'
    },
    info: {
      color: '#0d8de7'
    }
  }
};
